if (!customElements.get("mobile-tab-bar")) {
  class MobileTabBar extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll("[data-tab-action]"));

      // Menu / search / cart tabs click the header's drawer triggers,
      // so the drawers keep their lazy-loaded content and state.
      this.tabs.forEach((link) => {
        link.addEventListener("click", (e) => this.onTabClick(e, link));
      });

      if (this.classList.contains("tab-bar--autohide")) {
        this.bindAutohide();
      }

      if (this.hasAttribute("data-buy-mode")) {
        this.bindBuyMode();
      }

      this.bindMenuState();
    }

    // The bar stays on top of the open menu, so the burger reports open/closed
    bindMenuState() {
      var menuLink = this.querySelector("[data-tab-action='menu']");
      if (!menuLink) return;
      menuLink.setAttribute("aria-expanded", "false");

      var sync = (e) => {
        if (!e.detail || e.detail.id !== "menu") return;
        menuLink.setAttribute("aria-expanded", e.type === "overlay:opened" ? "true" : "false");
      };
      document.body.addEventListener("overlay:opened", sync);
      document.body.addEventListener("overlay:closed", sync);
    }

    onTabClick(e, link) {
      var action = link.getAttribute("data-tab-action");

      // Placeholder until the chat app is wired in
      if (action === "chat") {
        e.preventDefault();
        return;
      }

      // Stories open on top of everything: close the menu behind them
      if (action === "stories") {
        var menu = document.querySelector("wdn-drawer[data-id='menu']");
        if (menu && menu.isActive) menu.close();
      }

      if (["menu", "search", "cart"].indexOf(action) === -1) return;

      var trigger = document.querySelector(
        ".header wdn-drawer-open[data-id='" + action + "']"
      );
      // No drawer (e.g. cart on the cart page): follow the href
      if (!trigger) {
        if (action === "menu") e.preventDefault();
        return;
      }
      e.preventDefault();
      trigger.click();
    }

    bindAutohide() {
      var lastY = window.scrollY;
      var ticking = false;
      window.addEventListener(
        "scroll",
        () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => {
            var y = window.scrollY;
            var hide = y > lastY && y > 120 && !this.classList.contains("tab-bar--buy");
            this.classList.toggle("tab-bar--hidden", hide);
            lastY = y;
            ticking = false;
          });
        },
        { passive: true }
      );
    }

    // Follows the product page's sticky ATC (template-product.js sets data-fix-top)
    bindBuyMode() {
      var floatbuy = document.querySelector(".product__floatbuy");
      var buyItem = this.querySelector(".tab-bar-item--buy");
      if (!floatbuy || !buyItem || floatbuy.hasAttribute("data-floatbuy-disabled")) return;

      var buyButton = buyItem.querySelector("button");
      var sync = () => {
        var on = floatbuy.hasAttribute("data-fix-top");
        this.classList.toggle("tab-bar--buy", on);
        buyItem.setAttribute("aria-hidden", on ? "false" : "true");
        buyButton.tabIndex = on ? 0 : -1;
        if (on) this.classList.remove("tab-bar--hidden");
      };

      new MutationObserver(sync).observe(floatbuy, {
        attributes: true,
        attributeFilter: ["data-fix-top"],
      });
      sync();
    }
  }

  customElements.define("mobile-tab-bar", MobileTabBar);
}
